// extracted by mini-css-extract-plugin
module.exports = {"title":"title-mtI","footer":"footer-1qp","backBtn":"backBtn-2VC","backWrap":"backWrap-sAk","carStatus":"carStatus-1Ro"};